import {
	Box,
	Button,
	Card,
	Divider,
	Flex,
	Heading,
	SimpleGrid,
	Stack,
	Text,
	useColorModeValue,
} from '@chakra-ui/react';
import { NAVIGATE } from 'constant/navigation';
import { useLocation, useNavigate } from 'react-router-dom';
import EducationLinks from 'views/client/education/components/EducationLinks';

export default function Lightning() {
	const textColor = useColorModeValue('gray.900', 'gray.100');
	const cardBg = useColorModeValue('gray.100', 'gray.500');
	const navigate = useNavigate();
	const location = useLocation();
	let isClient = false;
	if (location.pathname.includes('client')) isClient = true;

	return (
		<Box
			maxW={isClient ? '' : '900px'}
			alignSelf={isClient ? '' : 'center'}
			pt={isClient ? { base: '80px', md: '80px', xl: '80px' } : '0'}
		>
			<SimpleGrid
				mb='20px'
				columns={{ sm: 1, md: 1, lg: 1 }}
				spacing={{ base: '20px' }}
			>
				<Heading color={textColor} fontSize='2xl' ms='24px' fontWeight='700'>
					¿Qué es Lightning Network?
				</Heading>
				<Flex direction='column'>
					<Card bg={cardBg} mb={isClient ? '20px' : '50px'} p={6}>
						<Stack spacing={6}>
							<Heading size='md' color={textColor}>
								⚡ Pagos instantáneos con Bitcoin
							</Heading>

							<Text fontSize='md' color={textColor}>
								Lightning es una red construida sobre Bitcoin que permite enviar
								y recibir pagos en segundos, con comisiones muy bajas, incluso
								de menos de un centavo.
							</Text>

							<Text fontSize='md' color={textColor}>
								Funciona como una autopista rápida para bitcoin, ideal para
								micropagos como los que ganas en Bumbei.
							</Text>

							<Divider />

							<Heading size='md' color={textColor}>
								📲 ¿Qué necesito para usarla?
							</Heading>

							<Text fontSize='md' color={textColor}>
								Solo necesitas una wallet compatible. Las más recomendadas para
								empezar son:
							</Text>

							<ul
								style={{
									paddingLeft: '1.5rem',
									color: textColor,
									fontSize: '16px',
								}}
							>
								<li>
									<strong>Muun Wallet</strong>: fácil, segura y sin custodia
								</li>
								<li>
									<strong>Blink Wallet</strong>: ideal para pagos rápidos y
									principiantes
								</li>
							</ul>

							<Text fontSize='md' color={textColor}>
								Una vez tengas tu wallet, solo agrega tu dirección Lightning en
								tu perfil de Bumbei y podrás retirar tu cashback sin límites
								mínimos.
							</Text>

							<Divider />

							<Heading size='md' color={textColor}>
								🚀 ¿Por qué Lightning importa?
							</Heading>

							<Text fontSize='md' color={textColor}>
								Lightning hace posible usar bitcoin en la vida diaria, no solo
								como inversión. Es una herramienta para darle utilidad real y
								acceso financiero a millones de personas.
							</Text>

							{isClient && (
								<Box pt={4}>
									<Button
										as='a'
										onClick={() => navigate(NAVIGATE.EDUCATION_CENTER)}
										variant='brand'
									>
										Volver al centro educativo
									</Button>
								</Box>
							)}
						</Stack>
					</Card>
					<EducationLinks current={'lightning'} isClient={isClient} />
				</Flex>
			</SimpleGrid>
		</Box>
	);
}
